<script setup>
import { useTheme } from "vuetify";
import ScrollToTop from "@core/components/ScrollToTop.vue";
import initCore from "@core/initCore";
import { initConfigStore, useConfigStore } from "@core/stores/config";
import { hexToRgb } from "@layouts/utils";

const { global } = useTheme();

// ℹ️ Sync current theme with initial loader theme
initCore();
initConfigStore();

const configStore = useConfigStore();

// SECTION: Loading Indicator
const router = useRouter();
const refLoadingIndicator = ref(null);
const isNavigating = ref(false);

// Thêm navigation guards để hiển thị loading indicator
router.beforeEach((to, from, next) => {
  if (to.path !== from.path) {
    isNavigating.value = true;
    if (refLoadingIndicator.value) {
      refLoadingIndicator.value.fallbackHandle();
    }
  }
  next();
});

router.afterEach(() => {
  isNavigating.value = false;
  if (refLoadingIndicator.value) {
    refLoadingIndicator.value.resolveHandle();
  }
});

// Xử lý lỗi navigation
router.onError(() => {
  isNavigating.value = false;
  if (refLoadingIndicator.value) {
    refLoadingIndicator.value.resolveHandle();
  }
});
// !SECTION
</script>

<template>
  <VLocaleProvider :rtl="configStore.isAppRTL">
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp
      :style="`--v-global-theme-primary: ${hexToRgb(
        global.current.value.colors.primary
      )}`"
    >
      <!-- Thêm AppLoadingIndicator -->
      <AppLoadingIndicator ref="refLoadingIndicator" />

      <RouterView />
      <ScrollToTop />
    </VApp>
  </VLocaleProvider>
</template>
